export function setURLSearchParam(key: string, value: string): void
{
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, value);

    const url = new URL(window.location.href);
    url.search = searchParams.toString();
    window.history.pushState(null, "", url.href);
}

export function getURLSearchParam(key: string): string | null
{
    const searchParams = new URLSearchParams(window.location.search);

    return searchParams.get(key);
}

export function clearURLSearchParam(...keys: string[]): void{
    const searchParams = new URLSearchParams(window.location.search);

    for(const key of keys)
    {
        searchParams.delete(key);
    }

    const url = new URL(window.location.href);
    url.search = searchParams.toString();
    window.history.replaceState(null, "", url.href);
}

export function createLink(params: { [key: string]: string }): string
{
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;

    for (const key in params)
    {
        searchParams.set(key, params[key]);
    }

    url.search = searchParams.toString();

    return url.href;
}

export function remoteFileExists(url: string): Promise<boolean> {
    try {
        return fetch(url, {
            cache: "no-store",
            method: "HEAD"
        }).then(response => response.status === 200).catch(() => false);
    } catch (error) {
        return Promise.resolve(false);
    }
}

const mimeTypes: {[type:string]: string} = {
    default: "text/plain",
    jpg: "image/jpeg",
    json: "application/json",
    mov: "video/quicktime",
    mp3: "audio/mpeg",
    mp4: "video/mp4",
    png: "image/png",
    wav: "audio/x-wav",
    zip: "application/zip"
}
export function getMimeTypeFromExtension(path: string): string {
    try {
        const url = new URL(path);
        const extension = url.pathname.split(".").pop() || "default";

        return mimeTypes[extension] || mimeTypes.default;
    }
    catch(exception) {
        const extension = path.split(".").pop() || "default";

        return mimeTypes[extension] || mimeTypes.default;
    }
}